import React from "react";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import FloatingLogo from "../FloatingLogo/FloatingLogo";
import { H2, MediumText, SuccessH2 } from "../../styles/Typography";
import {
  IconMailFilled,
  IconTelegramFilled,
  IconLink,
  IconLogin,
} from "../../assets/icons/Icon";
import {
  Column,
  Container,
  LinkContainer,
  SupportContainer,
  SupportLink,
  StyledLink,
  LoginLinkContainer,
  LoginLink,
} from "./LoginFormTemplates.styles";
import { Spinner } from "../../pages/CRUDPages/CRUDPages.styles";

export const supportContactsTemplate = (
  copyToastRef: React.RefObject<Toast | null>
) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText("software.support@i-d-tech.com");
      copyToastRef.current?.show({
        severity: "success",
        summary: "",
        detail: "Email скопирован в буфер обмена",
        life: 1500,
      });
    } catch (err) {
      console.error("Ошибка копирования:", err);
    }
  };

  return (
    <SupportContainer>
      <LinkContainer style={{ marginLeft: "20px" }}>
        <IconMailFilled size={16} />
        <SupportLink to="mailto:software.support@i-d-tech.com">
          software.support@i-d-tech.com
        </SupportLink>
        <Button
          text
          tooltip="Копировать email"
          tooltipOptions={{ position: "top" }}
          onClick={handleCopy}
        >
          <IconLink size={14} />
        </Button>
      </LinkContainer>
      <LinkContainer>
        <IconTelegramFilled size={16} />
        <SupportLink to="https://t.me/idtechSupport">
          t.me/idtechSupport
        </SupportLink>
      </LinkContainer>
    </SupportContainer>
  );
};

export const invalidLinkTemplate = (
  copyToastRef: React.RefObject<Toast | null>,
  label: string
) => (
  <Column>
    <Toast ref={copyToastRef} position="bottom-center" />
    <Container>
      <FloatingLogo />
      <H2>Упс...</H2>
      <MediumText>
        Это неверная ссылка {label}. <br /> Пожалуйста, обратитесь в{" "}
        <StyledLink to="https://t.me/idtechSupport">
          поддержку ООО "ИРТ"
        </StyledLink>
      </MediumText>
      {supportContactsTemplate(copyToastRef)}
    </Container>
  </Column>
);

export const userNotFoundTemplate = (
  copyToastRef: React.RefObject<Toast | null>
) => (
  <Column>
    <Toast ref={copyToastRef} position="bottom-center" />
    <Container>
      <FloatingLogo />
      <H2>Пользователь не найден</H2>
      <MediumText>
        Пожалуйста, обратитесь в{" "}
        <StyledLink to="https://t.me/idtechSupport">
          поддержку ООО "ИРТ"
        </StyledLink>
      </MediumText>
      {supportContactsTemplate(copyToastRef)}
    </Container>
  </Column>
);

export const successTemplate = (label: string) => (
  <Column>
    <Container>
      <FloatingLogo />
      <SuccessH2>Успешно!</SuccessH2>
      <MediumText>{label}</MediumText>
      <LoginLinkContainer>
        <LoginLink to="/login">
          Вход в систему <IconLogin size={20} />
        </LoginLink>
      </LoginLinkContainer>
    </Container>
  </Column>
);

export const loadingPage = () => (
  <Column>
    <Container>
      <Spinner>
        <ProgressSpinner />
        <p>Загрузка...</p>
      </Spinner>
    </Container>
  </Column>
);
